import { render, staticRenderFns } from "./SithMesStoolPrList.vue?vue&type=template&id=4810fce3&"
import script from "./SithMesStoolPrList.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolPrList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports